import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';
import ShopServiceModel from '@/models/ShopServiceModel';
import TimestampAble    from '@widesk-core/models/traits/TimestampAble';
import Blamable         from '@/models/traits/Blamable';

@model.urnResource('menu')
@doc.path('/menus/{?id}')
export default class MenuModel extends Blamable(TimestampAble(ShopServiceModel)) {
	private declare _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'reference': Shop_MenuReference;
		'label': id;
		'search': string;
	};

	private declare _tsSorts: {
		id: string;
		reference: string;
		label: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Shop_MenuReference;
}
